"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    title: 'Ops! Algo deu errado',
    description: 'Você pode escolher entre continuar o pagamento sem identificação ou tentar novamente.',
    continueWithoutIdentificationButton: 'Continuar sem identificação',
    retryButton: 'Tentar novamente',
    iconAltText: 'Ícone de exclamação vermelha',
};
